.Toasts {
  display: flex;
  flex-direction: column;
  gap: var(--font-size-md);
  max-width: var(--toast-max-width);
  position: fixed;
  right: 2rem;
  top: 8rem;
  z-index: var(--rv-z-toast);
}
